////////////////////////////////////////////////
//     JS Activatiion code for datepickers    //
////////////////////////////////////////////////

/////////////////////////////////
//          Front site        //
////////////////////////////////
$.fn.datepicker.defaults.format = "dd/mm/yyyy";

$.fn.datepicker.dates['fr'] = {
  days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
  daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
  daysMin: ["D", "L", "Ma", "Me", "J", "V", "S", "D"],
  months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  monthsShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Dec"],
  today: "Aujourd'hui",
  weekStart: 1
};

$.fn.datepicker.dates['es'] = {
  days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
  daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
  daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
  months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  today: "Hoy"
};

$.fn.datepicker.dates['zh-CN'] = {
  days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
  daysShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
  daysMin: ["日", "一", "二", "三", "四", "五", "六", "日"],
  months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  monthsShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  today: "今日",
  weekStart: 1
};

$.fn.datepicker.dates['ru'] = {
  days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
  daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб", "Вск"],
  daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
  months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
  monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  today: "Сегодня",
  weekStart: 1
};

$.fn.datepicker.dates['pt'] = {
  days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
  daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
  daysMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa", "Do"],
  months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  weekStart: 1
};

$.fn.datepicker.dates['it'] = {
  days: ["Domenica", "Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venerdi", "Sabato", "Domenica"],
  daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
  daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do"],
  months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  today: "Oggi",
  weekStart: 1
};

$.fn.datepicker.dates['de'] = {
  days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
  daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam", "Son"],
  daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
  months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  today: "Heute",
  weekStart: 1
};

$.fn.datepicker.dates['nl'] = {
  days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
  daysShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"],
  daysMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"],
  months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  today: "Vandaag",
  weekStart: 1
};


//////////////////////////////////
//          Admin Sidebar       //
//////////////////////////////////

$('#booking_arrival_date').datepicker({
  autoclose: true,
  assumeNearbyYear: true,
  startView: 'month',
  todayHighlight: true,
  weekStart: 1,
  language: (window.I18n && window.I18n.locale) || "en",
  startDate: '0d'
});

$('#booking_departure_date').datepicker({
  autoclose: true,
  assumeNearbyYear: true,
  startView: 'month',
  todayHighlight: true,
  weekStart: 1,
  language: (window.I18n && window.I18n.locale) || "en",
  startDate: '+1d'
});

// If the arrival date is past the departure date then the departure date is changed
// to arrival date + 1d
$('#booking_arrival_date').change(function () {
  var arrivalDate = ($('#booking_arrival_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('#booking_departure_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate >= departureDate) {
    var arrivalDatePlus1 = new Date(arrivalDate);
    arrivalDatePlus1.setDate(arrivalDatePlus1.getDate() + 1);
    $('#booking_departure_date').datepicker('update', arrivalDatePlus1);
  }
});

// If the departure date is before the arrival date then the arrival date is changed
// to departure date - 1d
$('#booking_departure_date').change(function () {
  var arrivalDate = ($('#booking_arrival_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('#booking_departure_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate >= departureDate) {
    var departureDateMinus1 = new Date(departureDate);
    departureDateMinus1.setDate(departureDateMinus1.getDate() - 1);
    $('#booking_arrival_date').datepicker('update', departureDateMinus1);
  }
});

//////////////////////////////////
//        Reservation list      //
//////////////////////////////////

$('#search_custom_arrival_date').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
});

$('#search_custom_departure_date').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
});

// If the arrival date is past the departure date then the departure date is changed
// to arrival date + 1d
$('#search_custom_arrival_date').change(function () {
  var arrivalDate = ($('#search_custom_arrival_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('#search_custom_departure_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate >= departureDate) {
    var arrivalDatePlus1 = new Date(arrivalDate);
    arrivalDatePlus1.setDate(arrivalDatePlus1.getDate() + 1);
    $('#search_custom_departure_date').datepicker('update', arrivalDatePlus1);
  }
});

// If the departure date is before the arrival date then the arrival date is changed
// to departure date - 1d
$('#search_custom_departure_date').change(function () {
  var arrivalDate = ($('#search_custom_arrival_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('#search_custom_departure_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate >= departureDate) {
    var departureDateMinus1 = new Date(departureDate);
    departureDateMinus1.setDate(departureDateMinus1.getDate() - 1);
    $('#search_custom_arrival_date').datepicker('update', departureDateMinus1);
  }
});


// If the arrival date is past the departure date then the end date is changed
// to arrival date + 1d
$('#search_custom_start_date').change(function () {
  var startDate = ($('#search_custom_start_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var endDate = ($('#search_custom_end_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (startDate >= endDate) {
    var startDatePlus1 = new Date(startDate);
    startDatePlus1.setDate(startDatePlus1.getDate() + 1);
    $('#search_custom_end_date').datepicker('update', startDatePlus1);
  }
});

// If the end date is before the start date then the start date is changed
// to end date - 1d
$('#search_custom_end_date').change(function () {
  var startDate = ($('#search_custom_start_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var endDate = ($('#search_custom_end_date').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (startDate >= endDate) {
    var endDateMinus1 = new Date(endDate);
    endDateMinus1.setDate(endDateMinus1.getDate() - 1);
    $('#search_custom_start_date').datepicker('update', endDateMinus1);
  }
});


//////////////////////////////////
//            Planning          //
//////////////////////////////////


// disable dates after +1 year from start date because user should not be allowed to update for more than 1 year

function addZ(n) { return n < 10 ? '0' + n : '' + n; }
window.addZ = addZ;

//////////////////////////////////
//           Report page       //
//////////////////////////////////





// If the arrival date is past the departure date then the departure date is changed
// to arrival date + 1d
$(document).on('change', '.auto-validate-a', function () {
  var arrivalDate = ($('.auto-validate-a').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('.auto-validate-d').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate > departureDate) {
    var arrivalDatePlus1 = new Date(arrivalDate);
    arrivalDatePlus1.setDate(arrivalDatePlus1.getDate() + 1);
    $('.auto-validate-d').datepicker('update', arrivalDatePlus1);
  }
});
// If the departure date is before the arrival date then the arrival date is changed
// to departure date - 1d
$(document).on('change', '.auto-validate-d', function () {
  var arrivalDate = ($('.auto-validate-a').datepicker('getFormattedDate')).split('/').reverse().join('/');
  var departureDate = ($('.auto-validate-d').datepicker('getFormattedDate')).split('/').reverse().join('/');
  if (arrivalDate > departureDate) {
    var departureDateMinus1 = new Date(departureDate);
    departureDateMinus1.setDate(departureDateMinus1.getDate() - 1);
    $('.auto-validate-a').datepicker('update', departureDateMinus1);
  }
});


//////////////////////////////////
//        Statistics page       //
//////////////////////////////////
$.fn.datepicker.defaults.format = "dd/mm/yyyy";

$('#statistics_custom_start_date').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
  format: "dd/mm/yyyy",
});

$('#statistics_custom_end_date').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
  format: "dd/mm/yyyy",
});


//////////////////////////////////
//          Trial Batcave       //
//////////////////////////////////

$('#subscription_trial_end').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
  format: "yyyy-mm-dd",
});

$('#search_custom_start_date').datepicker({
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
  format: "dd/mm/yyyy",
});



//////////////////////////////////
//          Estimate creation      //
//////////////////////////////////

const
datepickersConfig = {
  autoclose: true,
  todayHighlight: true,
  assumeNearbyYear: true,
  format: "dd/mm/yyyy",
  orientation: 'bottom left'
},
correctDatepickerCalendarPosition = () => {
  Amenitiz.correctDatepickerCalendarPosition('top', 3)
},
initializeEstimatePageDatepickers = () => {
  const datepickers = $('.form-input__date-picker--auto-width')
  datepickers
    .datepicker(datepickersConfig)
    .on('show', correctDatepickerCalendarPosition)
}

initializeEstimatePageDatepickers()
